import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GraduationCap, Award, Clock, ArrowRight } from "lucide-react";

const PERKS = [
  { icon: Clock, text: "Free 15-minute test", color: "#4ECDC4" },
  { icon: Award, text: "Certificate to download", color: "#FFE66D" },
];

const QuizBanner = () => (
  <section className="relative px-6 py-10 md:py-14" data-testid="home-quiz-banner">
    <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="relative max-w-7xl mx-auto overflow-hidden rounded-[2rem] border border-white/10 bg-[#0E1638]">
      <div className="absolute -top-24 -left-20 w-80 h-80 rounded-full bg-[#4ECDC4]/25 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-28 right-10 w-96 h-96 rounded-full bg-[#A855F7]/20 blur-3xl pointer-events-none" />
      <div className="absolute top-6 right-1/3 w-56 h-56 rounded-full bg-[#FFE66D]/10 blur-3xl pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/[0.06] to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-[#4ECDC4] via-[#FFE66D] via-60% to-[#FF6B6B]" />

      <div className="relative grid lg:grid-cols-[1fr_auto] gap-8 items-center p-7 md:p-12">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-[#FFE66D]/15 text-[#FFE66D] mb-4" data-testid="home-quiz-banner-badge">
            <GraduationCap className="w-3.5 h-3.5" /> Free Parent Quiz
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white leading-[1.1] mb-3" data-testid="home-quiz-banner-title">
            How well do you know your <span className="text-[#4ECDC4]">child's growth?</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg max-w-2xl mb-6">
            Answer 10 quick questions on growth and nutrition. Score 7 or more and you're a High Performer.
          </p>
          <div className="flex flex-wrap gap-3">
            {PERKS.map(({ icon: Icon, text, color }) => (
              <span key={text} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-sm text-white/80">
                <Icon className="w-4 h-4" style={{ color }} /> {text}
              </span>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-start lg:items-center gap-3">
          <Link to="/parent-quiz" data-testid="home-quiz-banner-cta"
            className="group btn-coral px-8 py-4 rounded-full font-semibold text-base inline-flex items-center gap-2 whitespace-nowrap">
            Take the free quiz <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <p className="text-xs text-white/40">Login required · takes 15 minutes</p>
        </div>
      </div>
    </motion.div>
  </section>
);

export default QuizBanner;
